<template>
    <a-modal :open="open" title="简易编辑" width="85%" :footer="null" @cancel="handleCancel" :destroyOnClose="true"
        :maskClosable="false">
        <a-spin :spinning="state.loading" :tip="state.tip">
            <div class="simple-edit-body">
                <a-form ref="formRef" :model="formState" :rules="rules" :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 18 }">
                    <!-- 6个单选，一行3个 -->
                    <a-row :gutter="16">
                        <a-col :span="9">
                            <a-form-item label="主体类型" required>
                                <a-radio-group v-model:value="formState.main_type" button-style="solid"
                                    class="radio-group radio-group-auto">
                                    <a-radio-button :value="1">公司</a-radio-button>
                                    <a-radio-button :value="2">个体户</a-radio-button>
                                    <a-radio-button :value="3">个独</a-radio-button>
                                    <a-radio-button :value="4">合伙</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :span="7">
                            <a-form-item label="收费标准" required>
                                <a-radio-group v-model:value="formState.fee_standard" button-style="solid"
                                    class="radio-group radio-group-auto">
                                    <a-radio-button :value="1">按年收费</a-radio-button>
                                    <a-radio-button :value="2">一次性收费</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="税务身份" required>
                                <a-radio-group v-model:value="formState.is_ybr" button-style="solid"
                                    class="radio-group radio-group-auto">
                                    <a-radio-button :value="2">小规模纳税人</a-radio-button>
                                    <a-radio-button :value="1">一般纳税人</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16">
                        <a-col :span="9">
                            <a-form-item label="业务类型" required>
                                <a-radio-group v-model:value="formState.business_type" button-style="solid"
                                    class="radio-group radio-group-auto">
                                    <a-radio-button :value="1">设立</a-radio-button>
                                    <a-radio-button :value="2">同区迁入</a-radio-button>
                                    <a-radio-button :value="3">跨区迁入</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :span="7">
                            <a-form-item label="注册类型" required>
                                <a-radio-group v-model:value="formState.registration_type" button-style="solid"
                                    class="radio-group radio-group-auto">
                                    <a-radio-button :value="1">包注册</a-radio-button>
                                    <a-radio-button :value="2">出裸地址</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="分支机构" required>
                                <a-radio-group v-model:value="formState.is_filiale" button-style="solid"
                                    class="radio-group radio-group-auto">
                                    <a-radio-button :value="2">否</a-radio-button>
                                    <a-radio-button :value="1">是</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <!-- 是否可录单 -->
                    <a-form-item
                        v-if="!((formState.main_type == 1 || formState.main_type == 3) && formState.business_type == 1)"
                        name="is_auto" label="是否可录单">
                        <a-switch :checkedValue="1" :unCheckedValue="2" v-model:checked="formState.is_auto"
                            checked-children="资料已确定，资料员可以录单了" un-checked-children="还有资料未确定，资料员不要录单" />
                    </a-form-item>
                    <a-form-item label="平台对接人手机号(选填)" name="platform_person_mobile">
                        <a-input v-model:value="formState.platform_person_mobile" placeholder="请输入平台对接人手机号"></a-input>
                    </a-form-item>
                    <a-form-item label="平台对接人微信号或其他(选填)" name="platform_wechat_account">
                        <a-input v-model:value="formState.platform_wechat_account" placeholder="请输入平台对接人微信号"></a-input>
                    </a-form-item>
                    <!-- 待注册主体名称 ✅ 修改：去掉v‑model，显式 value + update:value，切断对象引用 -->
                    <a-form-item name="entityNameToRegister" required label="待注册主体名称">
                        <PrincipalName ref="principalNameRef" :principalType="formState.main_type"
                            :business_type="formState.business_type" :isFiliale="formState.is_filiale" :push_system="1"
                            :is_heming="2" v-model:value="formState.entityNameToRegister" />
                    </a-form-item>
                    <!-- 注册详细地址 -->
                    <a-form-item name="registration_address" label="注册详细地址">
                        <a-input placeholder="请输入注册详细地址（选填）" v-model:value="formState.registration_address" />
                    </a-form-item>
                    <!-- 工商预留手机号码 -->
                    <a-form-item label="工商预留手机号码" name="registration_mobile" required>
                        <a-input @change="phoneOrLandlineChange('registration_mobile')"
                            v-model:value="formState.registration_mobile" placeholder="请输入工商预留手机号码">
                            <template #suffix>
                                <a-tooltip title="此手机号码将提交给工商局,会有很多广告电话打进来,请谨慎留取">
                                    <InfoCircleOutlined style="color: rgba(0, 0, 0, 0.45)" />
                                </a-tooltip>
                            </template>
                        </a-input>
                    </a-form-item>
                    <!-- 代理商姓名 -->
                    <a-form-item label="代理商姓名" name="seller" required>
                        <a-input v-model:value="formState.seller" placeholder="请输入代理商姓名" />
                    </a-form-item>
                    <!-- 续费联系人手机号码 -->
                    <a-form-item label="续费联系人手机号码" name="xftel">
                        <a-input @change="phoneChange('xftel')" v-model:value="formState.xftel"
                            placeholder="请输入续费联系人手机号码" />
                    </a-form-item>
                    <!-- 代理商注册拿货价格 + 代理商来年续费价格 同一行 -->
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item :label="'代理商【' + (formState.seller || '资料员') + '】注册价格'" name="dls_bzc_price"
                                :labelCol="{ span: 12 }" :wrapperCol="{ span: 8 }">
                                <a-input type="number" prefix="￥" suffix="元" v-model:value="formState.dls_bzc_price"
                                    placeholder="请输入代理商注册价格" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item v-if="formState.fee_standard === 1" :labelCol="{ span: 12 }"
                                :wrapperCol="{ span: 12 }" :label="'代理商【' + (formState.seller || '资料员') + '】来年续费价格'"
                                name="dls_xf_price">
                                <a-input type="number" prefix="￥" suffix="元" v-model:value="formState.dls_xf_price"
                                    placeholder="请输入代理商来年续费价格" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <!-- 给续费联系人注册价 + 给续费联系人续费价 同一行 -->
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="给续费联系人注册价" name="xflxr_zc_price" :labelCol="{ span: 12 }"
                                :wrapperCol="{ span: 8 }">
                                <a-input type="number" prefix="￥" suffix="元" v-model:value="formState.xflxr_zc_price"
                                    placeholder="请输入给续费联系人注册价" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item v-if="formState.fee_standard === 1" label="给续费联系人续费价" name="xflxr_xf_price"
                                :labelCol="{ span: 12 }" :wrapperCol="{ span: 12 }">
                                <a-input type="number" prefix="￥" suffix="元" v-model:value="formState.xflxr_xf_price"
                                    placeholder="请输入给续费联系人续费价" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <!-- 微信服务群 + 备注 同一行 -->
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="微信服务群（优先反馈）" name="weixinqun" :labelCol="{ span: 12 }"
                                :wrapperCol="{ span: 8 }">
                                <a-input v-model:value="formState.weixinqun" placeholder="请输入客户服务群" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="备注(保密,仅自己可见)" name="remark" :labelCol="{ span: 12 }"
                                :wrapperCol="{ span: 12 }">
                                <a-input v-model:value="formState.remark" placeholder="请输入备注" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <!-- 提交按钮 -->
                    <div class="form-footer">
                        <a-button @click="handleCancel">取消</a-button>
                        <a-button type="primary" :loading="state.confirmLoading" @click="onFormSubmit">
                            保存修改
                        </a-button>
                    </div>
                </a-form>
            </div>
        </a-spin>
    </a-modal>
</template>
<script lang="ts" setup>
import baseService from '@/utils/http/axios'
import { InfoCircleOutlined } from '@ant-design/icons-vue'
import PrincipalName from './components/form/PrincipalName.vue'
import { onMounted, reactive, ref, watch, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import { mobileOrLandlineRequiredValidator } from '@/utils/util'
import ls from '@/utils/Storage'
const UserInfo = ls.get('USER_INFO')
const props = defineProps<{
    open: boolean
    record: any
}>()
const emit = defineEmits(['ok', 'cancel'])
const formRef = ref()
const principalNameRef = ref()


onMounted(() => {
    queryDetail()
})
const queryDetail = () => {
    state.loading = true
    let requestParam = {
        url: `/admin/v1/customer/${props.record.id}/edit`,
        method: 'get'
    }
    baseService(requestParam)
        .then(async (res: any) => {
            let record = res.data
            // 🔑 直接使用 record.entityNameToRegister
            const entityNameToRegister = record.entityNameToRegister || getDefaultEntityNameToRegister()

            Object.assign(formState, {
                id: record.id || 0,
                main_type: record.main_type || 1,
                business_type: record.business_type || 1,
                is_ybr: record.is_ybr || 2,
                is_filiale: record.is_filiale || 2,
                registration_type: record.registration_type || 1,
                is_auto: record.is_auto || 1,
                dls_bzc_price: record.dls_bzc_price ?? record.dls_price ?? null,
                dls_xf_price: record.dls_xf_price ?? null,
                entityNameToRegister: entityNameToRegister,
                registration_address: record.registration_address || record.registered_address || null,
                registration_mobile: record.registration_mobile || '',
                fee_standard: record.fee_standard || 1,
                seller: record.seller || UserInfo?.nickname || '',
                xflxr_zc_price: record.xflxr_zc_price ?? null,
                xflxr_xf_price: record.xflxr_xf_price ?? null,
                xftel: record.xftel || '',
                weixinqun: record.weixinqun || '',
                remark: record.remark || null,
                upload_path: record.upload_path || '',
                platform_wechat_account: record.platform_wechat_account || '',
                platform_person_mobile: record.platform_person_mobile || ''
            })

        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            }
        }).finally(() => {
            state.loading = false
        })
}

interface EntityNameToRegister {
    no_word: number
    full_name: string
    no_postfix: number
    name_division: string
    name_word_mark: string
    filiale_full_name: string | null
    organizational_form: string
    name_division_position: number
    ondustry_representation: string
    ondustry_representation_id: number | null
    ondustry_representation_four: string | null
    ondustry_representation_type: string
}
interface FormState {
    id: number
    main_type: number
    business_type: number
    is_ybr: number
    is_filiale: number
    registration_type: number
    is_auto: number
    dls_bzc_price: number | null
    dls_xf_price: number | null
    entityNameToRegister: EntityNameToRegister
    registration_address: string | null
    registration_mobile: string
    fee_standard: number
    seller: string
    xflxr_zc_price: number | null
    xflxr_xf_price: number | null
    xftel: string
    weixinqun: string
    remark: string | null
    upload_path: string
    platform_wechat_account: string
    platform_person_mobile: string
}
const getDefaultEntityNameToRegister = (): EntityNameToRegister => ({
    no_word: 0,
    full_name: '',
    no_postfix: 0,
    name_division: '',
    name_word_mark: '',
    filiale_full_name: null,
    organizational_form: '',
    name_division_position: 0,
    ondustry_representation: '',
    ondustry_representation_id: null,
    ondustry_representation_four: null,
    ondustry_representation_type: ''
})
const getDefaultFormState = (): FormState => ({
    id: 0,
    main_type: 1,
    business_type: 1,
    is_ybr: 2,
    is_filiale: 2,
    registration_type: 1,
    is_auto: 1,
    dls_bzc_price: null,
    dls_xf_price: null,
    entityNameToRegister: getDefaultEntityNameToRegister(),
    registration_address: null,
    registration_mobile: '',
    fee_standard: 1,
    seller: UserInfo?.nickname || '',
    xflxr_zc_price: null,
    xflxr_xf_price: null,
    xftel: '',
    weixinqun: '',
    remark: null,
    upload_path: '',
    platform_wechat_account: '',
    platform_person_mobile: ''
})
const formState = reactive<FormState>(getDefaultFormState())
interface State {
    loading: boolean
    tip: string
    confirmLoading: boolean
}
const state = reactive<State>({
    loading: false,
    tip: '加载中...',
    confirmLoading: false
})
const checkEntityNameToRegister = (rule: any, value: EntityNameToRegister) => {
    if (!value) return Promise.reject('请填写主体名称')
    if (!value.organizational_form) return Promise.reject('请输入组织形式')
    if (formState.is_filiale == 1) {
        if (!value.filiale_full_name) return Promise.reject('请输入总公司名称')
        if (!value.name_word_mark && value.no_word != 1) return Promise.reject('请输入字号')
    } else {
        if (!value.name_division) return Promise.reject('请输入名称区划')
        if (!value.name_word_mark) return Promise.reject('请输入字号')
        if (!value.ondustry_representation) return Promise.reject('请输入行业表述')
    }
    return Promise.resolve()
}
const rules: Record<string, Rule[]> = {
    entityNameToRegister: [{ validator: checkEntityNameToRegister }],
    registration_mobile: [{ required: true, validator: mobileOrLandlineRequiredValidator }]
}

// ✅ 子组件 update:value 回调，做浅拷贝切断引用，防止子组件内部对象直接污染父reactive
const handleEntityNameChange = (payload: EntityNameToRegister) => {
    formState.entityNameToRegister = { ...payload }
    // 清除该字段旧校验提示
    formRef.value?.clearValidate(['entityNameToRegister'])
}

// 修复：不再拿event.target，直接拿 formState 上的值
const phoneChange = (type: string) => {
    const raw = (formState as any)[type] ?? ''
    const str = raw.replace(/\D/g, '')
    if (/^1[23456789]\d{9}$/.test(str)) {
        (formState as any)[type] = str
    } else {
        (formState as any)[type] = str
    }
}
const phoneOrLandlineChange = (type: string) => {
    const raw = (formState as any)[type] ?? ''
    const str = raw.replace(/\D/g, '')
    if (/^1[23456789]\d{9}$/.test(str) || /^0\d{2,3}-?\d{7,8}$/.test(str)) {
        (formState as any)[type] = str
    } else {
        (formState as any)[type] = str
    }
}

// 提交
const onFormSubmit = () => {
    formRef.value?.validate().then(() => {
        const submitData = {
            id: formState.id,
            main_type: formState.main_type,
            business_type: formState.business_type,
            is_ybr: formState.is_ybr,
            is_filiale: formState.is_filiale,
            registration_type: formState.registration_type,
            is_auto: formState.is_auto,
            dls_bzc_price: formState.dls_bzc_price,
            dls_xf_price: formState.dls_xf_price,
            entityNameToRegister: formState.entityNameToRegister,
            registration_address: formState.registration_address,
            registration_mobile: formState.registration_mobile,
            fee_standard: formState.fee_standard,
            seller: formState.seller,
            xflxr_zc_price: formState.xflxr_zc_price,
            xflxr_xf_price: formState.xflxr_xf_price,
            xftel: formState.xftel,
            weixinqun: formState.weixinqun,
            remark: formState.remark,
            platform_wechat_account: formState.platform_wechat_account,
            platform_person_mobile: formState.platform_person_mobile
        }
        state.confirmLoading = true
        baseService({
            url: '/admin/v1/customer/simpleEdit',
            method: 'post',
            data: submitData
        })
            .then((res: any) => {
                state.confirmLoading = false
                if (res.code === 0) {
                    message.success(res.msg || '修改成功')
                    emit('ok')
                } else {
                    message.warning(res.msg || '修改失败')
                }
            })
            .catch((err: any) => {
                state.confirmLoading = false
                if (err?.data?.code === 0 || err?.code === 0) {
                    message.success(err?.data?.msg || err?.msg || '修改成功')
                    emit('ok')
                    return
                }
                const errMsg = err?.msg || err?.data?.msg || err?.message || '修改失败，请稍后重试'
                message.warning(errMsg)
            })
    }).catch(() => { })
}
const handleCancel = () => {
    emit('cancel')
}
</script>
<style lang="less" scoped>
.simple-edit-body {
    padding: 10px 20px;
    max-height: 70vh;
    overflow-y: auto;

    .radio-group-auto {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;

        .ant-radio-button-wrapper {
            flex: 0 0 auto;
            text-align: center;
            padding: 0 16px;
            white-space: nowrap;
        }
    }

    :deep(.ant-form-item) {
        margin-bottom: 28px;

        .ant-form-item-label {
            text-align: right;
            padding-right: 12px;
            font-weight: 500;
            line-height: 32px;
        }
    }

    .form-footer {
        display: flex;
        justify-content: center;
        gap: 16px;
        padding: 20px 0 10px 0;
        border-top: 1px solid #f0f0f0;
        margin-top: 10px;

        .ant-btn {
            min-width: 100px;
        }
    }
}
</style>
